import { Injectable } from '@angular/core';
import {HttpInterceptor,HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse,HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import {LogserviceService} from '../logservice/logservice.service';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
  })
};

@Injectable({
  providedIn: 'root'
})
export class AdvancedSearchService {
  
  constructor(private httpClient:HttpClient ,private logService:LogserviceService) { }
  httpHeaders = new HttpHeaders();

  backendUrl = environment.apiURL;

  getPayload(data){
    let payload:any = {};  
    for(let i in data){
        if(data[i] != "" && data[i] != null){
            payload[i] = data[i];
        }
    }
    return payload;
  } 
  getSearchData(payload){
    //var payload = {"entityName": name};
    return this.httpClient.post(this.backendUrl+ 'person/search',payload, httpOptions).pipe(retry(2), catchError(this.handleError));
  }
  getSearchDataV1(payload){
    //var payload = {"entityName": name};
    return this.httpClient.post(this.backendUrl+ 'person/searchv1',payload, httpOptions).pipe(retry(2), catchError(this.handleError));
  }
  
  private handleError(errorObj: HttpErrorResponse | any) {
    const _self = this;
    let errorMessage: string;
    let body: any;
    if (errorObj instanceof HttpErrorResponse) {
      if (errorObj.ok === false && errorObj.status === 0) {
        errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime. Metadata';
      } else {
        body = errorObj.error || '';
        errorMessage = body.message ? body.message : body.error.message;
      }
    }
    return throwError(errorMessage);
  }
  
}
